<template>
  <v-card
    v-if="$store.getters.retrieveIsCashCustomer && !$store.getters.retrieveAnon"
    :loading="loading"
    :flat="!outlined"
    :outlined="outlined"
    class="flexcard"
  >
    <template slot="progress">
      <v-progress-linear color="blue darken-2" indeterminate />
    </template>

    <v-row align="start" v-if="showSelectAddress">
      <v-col cols="12">
        <v-banner icon="mdi-map-marker">
          Delivery Address
          <template v-slot:actions>
            <v-btn
              color="success"
              exact
              :to="{
                name: 'DeliveryAddressForm',
                params: { isNew: true, data: {} },
              }"
            >
              <v-icon left>add_circle_outline</v-icon> Add Address
            </v-btn>
            <v-btn
              class="ma-2 white--text"
              color="blue darken-2"
              exact
              @click="
                $router.push({
                  name: 'DeliveryAddressSelect',
                  params: { onSelectBack: true },
                })
              "
            >
              <v-icon left>mdi-swap-horizontal</v-icon>Select Address
            </v-btn>
          </template>
        </v-banner>
      </v-col>
    </v-row>

    <v-list-item v-if="address && Object.keys(address).length !== 0">
      <v-list-item-content>
        <v-list-item-subtitle>
          <v-text-field
            disabled
            hide-details="auto"
            :rules="[required('Name')]"
            :value="address.name"
            prepend-icon="mdi-account-box-outline"
          />
        </v-list-item-subtitle>

        <v-list-item-subtitle>
          <v-text-field
            disabled
            hide-details="auto"
            :rules="[required('Address')]"
            :value="address.address_line_1"
            prepend-icon="home"
          />
        </v-list-item-subtitle>

        <v-list-item-subtitle>
          <v-text-field
            disabled
            hide-details="auto"
            :value="address.address_line_2"
            prepend-icon="mdi-empty"
          />
        </v-list-item-subtitle>

        <v-list-item-subtitle>
          <v-text-field
            disabled
            hide-details="auto"
            :value="address.address_line_3"
            prepend-icon="mdi-empty"
          />
        </v-list-item-subtitle>

        <v-list-item-subtitle>
          <v-text-field
            disabled
            hide-details="auto"
            :value="address.address_line_4"
            prepend-icon="mdi-empty"
          />
        </v-list-item-subtitle>

        <v-list-item-subtitle>
          <v-text-field
            disabled
            hide-details="auto"
            :rules="[required('Postcode')]"
            :value="address.postcode"
            prepend-icon="mdi-post"
          />
        </v-list-item-subtitle>

        <v-list-item-subtitle>
          <v-text-field
            disabled
            hide-details="auto"
            :rules="[required('Telephone No.')]"
            :value="address.telephone"
            prepend-icon="phone"
          />
        </v-list-item-subtitle>

        <v-list-item-subtitle>
          <v-text-field
            disabled
            hide-details="auto"
            :rules="[required('Order Email')]"
            :value="address.order_email"
            prepend-icon="email"
          />
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-else>
      <v-list-item-content>
        <v-list-item-subtitle>
          <v-text-field
            v-if="loading"
            disabled
            label="Checking Address"
            hide-details="auto"
            :rules="[required('Name')]"
            :value="address.name"
          />

          <v-text-field
            v-else
            disabled
            label="Please Enter or Select an Address"
            hide-details="auto"
            :rules="[required('Name')]"
            :value="address.name"
          />
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: "SelectedAddress",

  props: {
    showSelectAddress: Boolean,
    outlined: Boolean,
  },

  data() {
    return {
      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
    };
  },

  computed: {
    loading() {
      return this.$store.getters.retrieveDeliveryAddressesLoading;
    },

    address() {
      if (this.$store.getters.retrieveSelectedAddress) {
        return this.$store.getters.retrieveSelectedAddress;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.selected_card
  color: var(--v-color-base) !important
  background-color: var(--v-background-base) !important
  border-color: var(--v-success-base) !important

.flexcard
  display: flex
  flex-direction: column
  height: 100%
  & .v-toolbar
    flex: 0

.address_line
  height: 20px

.v-text-field
  padding-top: 0
</style>